import styled from "styled-components";
import {TopBannerLiveLogoDefaultBox} from "./top-banner-live-logo.default.box";

export const TopBannerLiveLogoCasino777Box = styled(TopBannerLiveLogoDefaultBox)`
`;